import clsx from "clsx";
import type { NextPage } from "next";
import Head from "next/head";
import Image from "next/image";
import { useSearchParams } from "next/navigation";

import { Button, H1 } from "@chapter/react-native-components";

const EmbedPage: NextPage<{}> = () => {
    const searchParams = useSearchParams();
    const landingPageUrl = "https://app.askchapter.org/landing-app";
    const source = searchParams?.get("utm_campaign");

    const welcomeCta = (
        <div className="flex flex-col items-center">
            <div className="mb-6">
                <Image
                    src="https://www.datocms-assets.com/73690/1720207837-chapter-otc-app.png"
                    width={258}
                    height={31.9}
                    alt={"Chapter Logo"}
                />
            </div>
            <H1 className="text-brand-plum-light text-center leading-none">
                The easiest way to redeem your flex card benefits.
            </H1>
        </div>
    );

    const buttons = (
        <Button
            type={{ value: "primary", alt: true }}
            size={{ height: "md", width: "full" }}
            className="mt-8"
            onClick={() => {
                window.open(source ? `${landingPageUrl}?utm_campaign=${source}` : landingPageUrl, "_blank");
            }}
            round
            content={{ text: "Sign up" }}
        />
    );

    return (
        <>
            <Head>
                <title>Chapter OTC</title>
            </Head>
            {/** larger screen sizes at sm or above */}
            <div className={clsx("hidden sm:flex", "h-[calc(100dvh)] w-full")}>
                <div className="px-auto flex w-full flex-1 flex-row items-center justify-center gap-x-14">
                    <div className="flex h-full items-center">
                        <div className="mx-auto flex w-[347px] flex-col items-center lg:w-[420px]">
                            {welcomeCta}
                            <div className="w-full px-5">{buttons}</div>
                        </div>
                    </div>
                    <div className="flex h-full items-center overflow-hidden">
                        <div className="mx-auto">
                            <Image
                                src="https://www.datocms-assets.com/73690/1718381337-app-notional.png"
                                alt="Chapter app on phone"
                                priority={true}
                                width={202.426}
                                height={415.584}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/** smaller screen sizes below sm */}
            {/**
             * The max height here prevents the buttons from getting to far down the screen in the edge case
             * where we have an extremely long but narrow screen
             */}
            <div className={clsx("flex sm:hidden", "h-[calc(100dvh)] max-h-[840px] w-full")}>
                <div className="flex h-full w-full flex-col items-center overflow-hidden pt-10">
                    <div className="z-10 px-5">{welcomeCta}</div>
                    <div className="relative mt-6 flex h-[570px] w-[290px] max-w-full flex-1 overflow-hidden">
                        <Image
                            src="https://www.datocms-assets.com/73690/1718381337-app-notional.png"
                            alt="Chapter app on phone"
                            priority={true}
                            fill
                            objectFit="contain"
                        />
                    </div>
                    <div className="absolute bottom-0 w-full max-w-[420px] bg-gradient-to-t from-gray-100 via-gray-100 to-[rgba(73,55,95,0)] pb-3 pt-10">
                        <div className="w-full px-5">{buttons}</div>
                        {/**
                         * This adds in some gray margin below the buttons so that it
                         * hides the image overflow on the bottom.
                         */}
                        <div className="h-10 bg-gray-100" />
                    </div>
                </div>
            </div>
            <div className="absolute bottom-3 left-3 text-sm text-[#B8BABE]">Advertisement</div>
        </>
    );
};

export default EmbedPage;
